import { get, post, put, Delete } from "../axios";

// news classify list
export const newsClassifyList = (params) =>
  get("/web/news/classify/list", params);

// news classify all list
export const newsClassifyListAll = (params) =>
  get("/web/news/classify/listAll", params);

// news classify add
export const newsClassifyAdd = (params) =>
  post("/web/news/classify/add", params);

// news classify update
export const newsClassifyUpdate = (params) =>
  put("/web/news/classify/update", params);

// news classify delete
export const newsClassifyDelete = (id) =>
  Delete("/web/news/classify/delete/" + id, "");

// news classify state update
export const newsClassifyState = (params) =>
  put("/web/news/classify/state/update", params);
